export default "__VITE_ASSET__W_IeTqD5__"